import React from 'react';
import { Image } from "../Image/index.mjs";
import { cssGraphicSize } from "../../styles/index.mjs";
export var ChipImage = function ChipImage(_ref) {
  var src = _ref.src,
    size = _ref.size;
  var imgSize = size === 'small' ? cssGraphicSize('base', 'decorative', '24px') : cssGraphicSize('larger', 'decorative', '32px');
  return /*#__PURE__*/React.createElement(Image, {
    src: src,
    crop: true,
    circle: true,
    imageHeight: imgSize,
    imageWidth: imgSize,
    alt: ""
  });
};